import api from './api';

export interface PulseHistoryParams {
  type?: string;
  limit?: number;
  offset?: number;
}

export interface PulseRunParams {
  pulse_type?: string;
  tier?: string;
  date_range_days?: number;
  persona_id?: string | null;
  model_override?: string | null;
}

const pulseService = {
  getHistory: async (params: PulseHistoryParams = {}) => {
    const response = await api.get('/pulses/history', {
      params: { pulse_type: params.type, limit: params.limit ?? 20, offset: params.offset ?? 0 },
    });
    return response.data;
  },

  getArtifact: async (artifactId: string) => {
    const response = await api.get(`/pulses/history/${artifactId}`);
    return response.data;
  },

  run: async (body: PulseRunParams = {}) => {
    const response = await api.post('/pulses/run', body);
    return response.data;
  },

  dryRun: async (body: PulseRunParams = {}) => {
    const response = await api.post('/pulses/dry-run', body);
    return response.data;
  },

  getConfig: async (pulseType: string) => {
    const response = await api.get(`/pulses/config/${pulseType}`);
    return response.data;
  },

  updateConfig: async (pulseType: string, body: Record<string, any>) => {
    const response = await api.put(`/pulses/config/${pulseType}`, body);
    return response.data;
  },

  list: async () => {
    const response = await api.get('/pulses/');
    return response.data;
  },
};

export default pulseService;
